import { render, staticRenderFns } from "./PurchaseIndex.vue?vue&type=template&id=50cde028&"
import script from "./PurchaseIndex.vue?vue&type=script&lang=js&"
export * from "./PurchaseIndex.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports